import React, { useEffect, useState, useRef } from 'react';
import {
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Upload,
  Spin,
  Radio,
  Select,
  DatePicker,
} from "antd";

import {
  SyncOutlined
} from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { getReferenceNoAsyn, fetchUserData, AddDocumentAsyn, getUsersNameAsyn, clearAllUsersNameState, clearAddResponseState, adddocumentSelector, clearState, clearResponseState } from './ChdAddDocumentSlice';
import moment from 'moment';
import { authSelector } from '../../Auth/authSlice';
import { myRef } from '../../newRef'

const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { TextArea } = Input;
const { Option } = Select;
let mxxx = "";

export default function AddDocument() {
  const { Option } = Select;
  const location = useLocation();
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory();
  const [subjectVal, setSubjectVal] = useState('')
  const [form] = Form.useForm();
  const [UserList, setUserList] = useState([]);
  const [setslecetedUserList] = useState([]);
  const [sendUserData, setsendUserData] = useState([]);

  const { isSuccess, isUsersNameSuccess, allUserNames, isError, errorMessage, response, isResponse, templates, referenceNos, isAddResponse } = useSelector(
    adddocumentSelector
  );

  if (location.state == undefined) {
    history.push("/dashboard");
    window.location.reload()
  }

  const { user } = useSelector(authSelector);
  const loggedInUser = user.username;

  useEffect(() => {
    dispatch(clearState());
    setLoading(true);
    dispatch(getReferenceNoAsyn());
    dispatch(getUsersNameAsyn());
  }, []);

  useEffect(() => {
    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage.toUpperCase());
    }
    if (isSuccess) {
      setLoading(false);
    }
    if (isResponse) {
      setLoading(false);
      dispatch(clearResponseState());
    }
    if (isAddResponse) {
      setLoading(false);
      dispatch(clearAddResponseState());
      history.push({
        pathname: '/verify-document',
        state: { documentInfo: response, processId: response.documentUpdatedData.processId }
      });
    }
    if (isUsersNameSuccess) {
      setUserList(allUserNames)
      dispatch(clearAllUsersNameState())
    }
  }, [isError, isSuccess, isUsersNameSuccess, isResponse, isAddResponse, allUserNames, setLoading, setToast]);

  const onClickListChange = (x, e) => {
    let dummyArray = []
    for (var i = 0; i < e.length; i++) {
      let data = {
        "username": e[i].props.username,
        "department": 'Chief of Air Staff',
        "departmentType": e[i].props.branch == true ? 'Branch'
          : e[i].props.independentOffice == true ? 'Independent Office'
            : e[i].props.independentDirectorate == true ? 'Independent Directorate'
              : null,
        "departmentTypeName": e[i].props.branch == true ? e[i].props.b_name
          : e[i].props.independentOffice == true ? e[i].props.io_name
            : e[i].props.independentDirectorate == true ? e[i].props.id_name
              : null,
        "directorateWithinBranch": e[i].props.bd_name ? e[i].props.bd_name : '',
        "firstName": e[i].props.fullName,
      }
      dummyArray.push(data)
    }
    setsendUserData([]);
    setsendUserData(dummyArray);
  };

  const newReferenceNos = () => {
    let refChild = []
    myRef.forEach(el => {
      let mx = el.substring(0, 7);
      refChild.push(<Option key={el} value={mx} props={el}>{el}</Option>);
    });
    return refChild;
  }

  if (((loggedInUser.indexOf('c') === 0) && (loggedInUser.indexOf('c') != -1))) {
    UserList.forEach(em => {
      if (em.username.includes(loggedInUser)) {
        mxxx = em.b_name;
        if (mxxx.includes("Communications")) { mxxx = "CIS"; }
        else if (mxxx.includes("Standard")) { mxxx = "COSE"; }
        else if (mxxx.includes("Budget")) { mxxx = "CAB"; }
        else if (mxxx.includes("Intelligence")) { mxxx = "CAI"; }
        else if (mxxx.includes("Policy")) { mxxx = "COPP"; }
        else if (mxxx.includes("Secretary")) { mxxx = "AIRSEC"; }
        else if (mxxx.includes("Logistic")) { mxxx = "LOG"; }
        else if (mxxx.includes("Training")) { mxxx = "CTOP"; }
        else if (mxxx.includes("Medical")) { mxxx = "CMS"; }
      }
    });
  } else {
    mxxx = loggedInUser.toUpperCase();
  }

  const shadowuserFunc = (theUser, usertocopy) => {
    let shadowUser = {
      "username": usertocopy,
      "department": 'Chief of Air Staff',
      "departmentType": theUser.departmentType,
      "departmentTypeName": theUser.departmentTypeName,
      "directorateWithinBranch": theUser.directorateWithinBranch,
      "firstName": usertocopy.toUpperCase(),
    }
    return shadowUser
  }

  const onFinish = (values) => {
    let tempArray = [...sendUserData];
    let someusers = [];
    for (var i = 0; i < sendUserData.length; i++) {
      someusers[i] = sendUserData[i].username;
    }
    for (var i = 0; i < sendUserData.length; i++) {
      let guser = sendUserData[i].username;
      if (((guser.indexOf('c') === 0) && (guser.indexOf('c') != -1) && !(guser.includes('cc'))) || (guser == "ccis")) {
        if (!someusers.includes("aa" + guser)) {
          const shadowUser = shadowuserFunc(sendUserData[i], "aa" + guser)
          tempArray = [...tempArray, shadowUser]; setsendUserData([...tempArray, shadowUser]);
        }
      }
      if (guser == "airsec") {
        if (!someusers.includes("aa" + guser)) {
          const shadowUser = shadowuserFunc(sendUserData[i], "aa" + guser)
          tempArray = [...tempArray, shadowUser]; setsendUserData([...tempArray, shadowUser]);
        }
      }
      if (i < 1) {
        if (((loggedInUser.indexOf('c') === 0) && (loggedInUser.indexOf('c') != -1) && !(loggedInUser.includes('cc')) || (loggedInUser == "ccis")) && (!someusers.includes(`cc${loggedInUser}`))) {
          let pa = `cc${loggedInUser}`
          const shadowUserpa = shadowuserFunc(sendUserData[i], pa);
          tempArray = [...tempArray, shadowUserpa]; setsendUserData([...tempArray, shadowUserpa]);
        }
        if ((loggedInUser == 'airsec') && (!someusers.includes(`cc${loggedInUser}`))) {
          let pa = `cc${loggedInUser}`
          const shadowUserpa = shadowuserFunc(sendUserData[i], pa);
          tempArray = [...tempArray, shadowUserpa]; setsendUserData([...tempArray, shadowUserpa]);
        }
        if ((loggedInUser == 'airsec') && (!someusers.includes(`aa${loggedInUser}`))) {
          let aa = `aa${loggedInUser}`
          const shadowUserpa = shadowuserFunc(sendUserData[i], aa);
          tempArray = [...tempArray, shadowUserpa]; setsendUserData([...tempArray, shadowUserpa]);
        }
        if (((loggedInUser.indexOf('c') === 0) && (loggedInUser.indexOf('c') != -1) && !(loggedInUser.includes('cc')) || (loggedInUser == "ccis")) && (!someusers.includes(`aa${loggedInUser}`))) {
          let aa = `aa${loggedInUser}`
          const shadowUseraa = shadowuserFunc(sendUserData[i], aa);
          tempArray = [...tempArray, shadowUseraa]; setsendUserData([...tempArray, shadowUseraa]);
        }
        if (!(loggedInUser.includes('dd')) && (loggedInUser.indexOf('d') != -1) && (loggedInUser.indexOf('d' == 0)) && (!someusers.includes(`pa${loggedInUser}`))) {
          let dpa = `cc${loggedInUser}`
          const shadowUserdpa = shadowuserFunc(sendUserData[i], dpa);
          tempArray = [...tempArray, shadowUserdpa]; setsendUserData([...tempArray, shadowUserdpa]);
        }
      }
    }
    localStorage.setItem("DOCREF", values.referenceNumber + "/" + mxxx);
    try {
      let document = {
        "documentId": location.state.documentId,
        "securityClassification": values.securityClassification,
        "documentType": values.documentType,
        "referenceNumber": values.referenceNumber + "/" + mxxx,
        "restrictDownload": values.restrictDownload == 'yes' ? true : false,
        "receivedFrom": values.receivedFrom ? values.receivedFrom : null,
        "controlNumber": values.controlNumber ? values.controlNumber : null,
        "casstickernote": values.casstickernote,
        "subject": values.subject,
        "signalDate": values.signalDate ? moment(values.signalDate).format() : null,
        "externalReferenceNumber": values.externalReferenceNumber ? values.externalReferenceNumber : null,
        "cos_seenStamp": null,
        "automaticTemplate": true,
        "users": tempArray,
      };
      setLoading(true);
      dispatch(AddDocumentAsyn(document));
    }
    catch (err) {
      alert("Error: " + err.message + " \nfull error: " + err);
      window.open("https://paperless.naf.inq.inc/");
    }
  };

  const onDateIncomingChange = (value, dateString) => { }

  const getAppt = () => {
    let selchildren = [];
    if (UserList && UserList.length > 0) {
      for (let i = 0; i < UserList.length; i++) {
        selchildren.push(<Option key={UserList[i].username} value={UserList[i].username} props={UserList[i]}>{UserList[i].username.toUpperCase()}</Option>);
      }
    }
    return selchildren;
  }

  // --- INLINE STYLES ---
  const styles = {
    spin: {
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111,
      left: 0, right: 0, top: '45%', bottom: 0
    },
    pageWrapper: { padding: '24px', paddingTop: '16px', background: '#f0f2f5', minHeight: '100vh' },
    formContainer: { 
      background: '#ffffff', 
      borderRadius: '12px', 
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)', 
      overflow: 'hidden',
      border: '1px solid #dfe0eb'
    },
    headerRow: {
      padding: '30px 50px',
      background: '#ffffff',
      borderBottom: '2px solid #f0f2f5'
    },
    formBody: { padding: '40px 50px' },
    formItemLabel: { fontStyle: "normal", fontWeight: "600", fontSize: 14, color: "#6B778C", marginBottom: 8 },
    infoText: { fontSize: 16, fontWeight: 'bold', color: '#172B4D', marginLeft: 10 },
    footerRow: {
      padding: '24px 50px',
      background: '#fafafa',
      borderTop: '1px solid #dfe0eb',
      textAlign: 'right'
    },
    input: { borderRadius: '6px', height: '44px' },
    textArea: { borderRadius: '6px', backgroundColor: "#fff", border: '1px solid #d9d9d9' }
  }

  return (
    <>
      <Container>
        <Spin indicator={antIcon} style={styles.spin} spinning={isLoading} />
        
        <Breadcrumb style={{ margin: "16px 0", paddingLeft: 50 }} separator=">">
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Add Document</Breadcrumb.Item>
        </Breadcrumb>

        <div style={styles.pageWrapper}>
          <div style={styles.formContainer}>
            <Toaster position="top-center" />

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={{ restrictDownload: 'Yes' }}
            >
              {/* HEADER */}
              <div style={styles.headerRow}>
                <Title level={3} style={{ margin: 0 }}>Add Document Details</Title>
              </div>

              {/* BODY */}
              <div style={styles.formBody}>
                <Row gutter={48}>
                  <Col span={12}>
                    <Form.Item label={<span style={styles.formItemLabel}>Process ID</span>}>
                      <Space>
                        <img src="./images/pdficon.png" style={{ width: "35px" }} alt="pdf" />
                        <span style={styles.infoText}>{location.state.processId}</span>
                      </Space>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={<span style={styles.formItemLabel}>Added On</span>}>
                      <span style={styles.infoText}>{moment(location.state.createdAt).format("D MMM YYYY")}</span>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={48} style={{ marginTop: 20 }}>
                  <Col span={12}>
                    <Form.Item
                      name="securityClassification"
                      label={<span style={styles.formItemLabel}>Security Classification</span>}
                      rules={[{ required: true, message: 'Required' }]}
                    >
                      <Select style={{ height: 44 }}>
                        <Option value="Restricted">Restricted</Option>
                        <Option value="Confidential">Confidential</Option>
                        <Option value="Secret">Secret</Option>
                        <Option value="Top-Secret">Top-Secret</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                   <Form.Item
  name="referenceNumber"
  label={<span style={styles.formItemLabel}>Reference No/Invoice No/ Doc No</span>}
  rules={[{ required: true, message: 'Required' }]}
>
  <Input 
    placeholder="Enter Reference Number" 
    style={{ height: 44, borderRadius: '6px' }} 
  />
</Form.Item>
                  </Col>
                </Row>

                <Row gutter={48}>
                  <Col span={12}>
                    <Form.Item
                      name="restrictDownload"
                      label={<span style={styles.formItemLabel}>Restrict Download</span>}
                    >
                      <Radio.Group>
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name="users_uuid"
                  label={<span style={styles.formItemLabel}>Select Recipients</span>}
                  style={{ marginTop: 20 }}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Search by appointment"
                    onChange={onClickListChange}
                    style={{ width: '100%' }}
                  >
                    {getAppt()}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="subject"
                  label={<span style={styles.formItemLabel}>Subject</span>}
                  rules={[{ required: true, message: 'Required' }]}
                  style={{ marginTop: 20 }}
                >
                  <TextArea rows={3} style={styles.textArea} placeholder="Enter subject" />
                </Form.Item>

                {/* <Form.Item
                  name="casstickernote"
                  label={<span style={styles.formItemLabel}>Sticker Note to CAS</span>}
                  style={{ marginTop: 20 }}
                >
                  <TextArea rows={2} style={styles.textArea} placeholder="Enter sticker note" />
                </Form.Item> */}
              </div>

              {/* FOOTER */}
              <div style={styles.footerRow}>
                <Link to="/dashboard">
                  <Button size="large" style={{ marginRight: 15 }}>Cancel</Button>
                </Link>
                <Button htmlType="submit" type="primary" size="large" style={{ background: '#ff4500', borderColor: '#ff4500' }}>
                  Next
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Container>
    </>
  );
}

// Custom Title Component for local use
const Title = ({ level, children, style }) => {
  const Tag = `h${level}`;
  return <Tag style={{ color: '#172B4D', fontWeight: 'bold', ...style }}>{children}</Tag>;
};